import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["search", "row", "status"]
  filter() {
    const query = this.searchTarget.value.trim().toLocaleLowerCase()
    let count = 0
    this.rowTargets.forEach(row => {
      row.hidden = !row.textContent.toLocaleLowerCase().includes(query)
      if (!row.hidden) count++
    })
    this.statusTarget.textContent = count ? `${count} of ${this.rowTargets.length} calendars` : "No matching calendars"
  }
}
